import AnalyticsContext from "../AnalyticsContext";

import LineGraph from "./Graphs/LineGraph";
import CachedGraph from "./Graphs/CachedGraph";
import AnalyticsUtil from "../AnalyticsUtil";
import StatisticUtil from "../StatisticUtil";
import GraphUtil from "./Graphs/GraphUtil";


class SessionDuration_Cohort_Line {

    static getId() {
        return "SessionDuration_Cohort_Line";
    }

    static getGraphProps(_props) {
        return {
            title: "Session Length (Cohort)",
            xAxis: "time",
            yAxis: "time",
        };
    }

    static getRequiredProps() {
        return ["filter"];
    }

    static getGraphData(_props, _cb) {
        const ctx = AnalyticsContext.getAsyncContext();
        let mergedFilters = JSON.parse(JSON.stringify(_props.filter));
        if (_props.startDate && _props.endDate) {
            mergedFilters.install_date = { from : _props.startDate, to: _props.endDate };
        }
        ctx.sendAsync("duration", {type: "analytics_v3", subType: "es_sessionDuration_v3", group: ["install_date","day",_props.group], filter: mergedFilters });
        ctx.sendAsync("installs", {type: "analytics_v3", subType: "es_user_v3", group: ["install_date",_props.group], filter: mergedFilters });
        ctx.waitForCompletion((_err, _data) => {
            if (_err) {
                return _cb(_err);
            } else {
                const installLookup = AnalyticsUtil.generateLookup(_data.installs.result.result, "install_date","installs", (_a) => parseInt(_a, 10));
                const pilDuration = AnalyticsUtil.addPil(_data.duration.result.result);
                let graphData = null;
                let pils = [0,3,7];
                for (let pilidx = 0; pilidx < pils.length; pilidx++) {
                    const pil = pils[pilidx];
                    const d0Duration = AnalyticsUtil.filterBy(pilDuration, (_e) => _e.pil <= pil && _e.maxPil >= pil);
                    const d0Data = AnalyticsUtil.aggregateBy(d0Duration, "install_date", "duration", StatisticUtil.sum);
                    AnalyticsUtil.scaleBy(d0Data, "install_date", "duration", (_a) => (1/installLookup[_a]));
                    for (let i = 0; i < d0Data.length; i++) {
                        d0Data[i].samples = installLookup[d0Data[i].install_date];
                    }
                    const graph = GraphUtil.generateNamedTimeseries("D"+pil,d0Data, "install_date", "duration");
                    graphData = GraphUtil.mergeReports(graphData, graph);
                }
                return _cb(null, graphData);
            }
        });
    }
}


export default CachedGraph(SessionDuration_Cohort_Line, LineGraph);